export default __webpack_public_path__ + "fc818b3d789896dccb15e8730c221bcf.png";